module.exports = __webpack_public_path__ + "img/swot.65a044eb.png";